import React from "react";
import Button from "../../common/Button/Button";
import "./demo-content.css";

function DemoContent() {
  return (
    <>
      <h4 className="mb-4 demo-title md:whitespace-nowrap">
        <span
          className="bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-teal-400"
          style={{ color: "#6E4CD1" }}
        >
          Сreate demo account
        </span>
        <br />
        with play money
      </h4>
      <div className="max-w-3xl mx-auto">
        <Button text="Try NOW" className="bg-amber-200" />
      </div>
    </>
  );
}

export default DemoContent;
